import { Flex, Skeleton, Table, Text, Tr } from '@chakra-ui/react';
import { Td } from '@chakra-ui/table';
import { firstLetterUpperCaseAndRestLowerCase } from '../../../../utils/capitalFirstLetter';

export function Summary({ data, loading, filtroPorPrazo, onClose }) {
  console.log(data)

  const counterNumPed = data?.filter(
    (item, index, self) => self.findIndex((t) => t.pedido_venda === item.pedido_venda) === index
  );

  const listPrazos = counterNumPed?.reduce((acc, item) => {
    const { PRAZO } = item;

    return {
      ...acc,
      [PRAZO]: (acc[PRAZO] || 0) + 1, // aqui estou somando a quantidade de prazos iguais
      total: (acc.total || 0) + 1 // aqui estou somando a quantidade total de prazos
    };
  }, {});

  const arrayPrazos = Object.entries(listPrazos).map(([key, value]) => {
    return { prazo: key, quantidade: value };
  });

  function handleFilterByPrazo(prazo) {
    filtroPorPrazo(prazo);
    onClose();
  }


  return (
    <Flex alignItems={'flex-start'} gap={5}>
      <Flex flexDir={'column'} paddingBlock={'16px'}>
        <Text
          bg={'#378BBF'}
          paddingBlock={'11px'}
          paddingInline={'36px'}
          fontWeight={'bold'}
          color={'#fff'}
          width={'100%'}
          mb={2}>
          Prazos
        </Text>
        {arrayPrazos.map((item, index) => (
          <Flex
            width={'180px'}
            key={index}
            alignItems={'center'}
            justifyContent={'space-between'}
            bg={index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'}
            paddingBlock={'4px'}
            paddingInline={'36px'}>
            <Text>
              {firstLetterUpperCaseAndRestLowerCase(item.prazo)}{' '}
              {item.prazo !== 'total' && `dia${Number(item.prazo) > 1 ? 's' : ''}`}:
            </Text>
            <Text
              fontWeight={'bold'}
              cursor={'pointer'}
              _hover={{ textDecoration: 'underline' }}
              onClick={() => {
                handleFilterByPrazo(item.prazo);
              }}>
              {item.quantidade}
            </Text>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}
